import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import {useDispatch} from 'react-redux';
import {Tooltip} from '@material-ui/core';
import {Icon} from 'front-onceforall-core';
import * as snackbarsActions from '../../../../actions/snackbars';
import {captureError} from '../../../../utils/log';
import {cancelInvitation} from '../../../../utils/relationship';
import authenticationService from '../../../../services/authentication/AuthenticationService';
import {status} from '../../../../utils/constant';

function CancelView(props) {
  const dispatch = useDispatch();
  const {invitation} = props;

  if (![status.PENDING, status.REJECTED].includes(invitation.status)) {
    return null;
  }

  const isBackOffice = authenticationService.roles().isBackOffice();
  const canCancel = authenticationService.roles().isManager() ||
    authenticationService.roles().isInviting() ||
    (authenticationService.roles().isExplorer() && props.isSubcontractorView);

  if (!isBackOffice && !canCancel) {
    return null;
  }

  function handleCancelInvitation() {
    cancelInvitation(invitation)
      .then(() => {
        dispatch(snackbarsActions.addSuccess(<Translate value="invite.cancelSuccessful"/>));
        props.onCancelSuccess();
      })
      .catch(error => {
        captureError('Error when canceling the invitation', error);
        dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
      });
  }

  return (
    <Tooltip title={I18n.t('invite.cancel')}>
      <button
        data-id="cancel-button"
        type="button"
        className={`small ${(isBackOffice && !canCancel) ? 'bo' : 'secondary'}`}
        onClick={handleCancelInvitation}
      >
        <Icon icon="trash"/>
      </button>
    </Tooltip>
  );
}

CancelView.propTypes = {
  invitation: PropTypes.object.isRequired,
  onCancelSuccess: PropTypes.func.isRequired,
  isSubcontractorView: PropTypes.bool
};

export default CancelView;
